import {AuthStatus, AuthState } from "@fitness-force/models";


export const authInitialState: AuthState = {
  loggedIn: false,
  status: AuthStatus.INIT,
  user: null,
  error:null,
  token:''
};
